import { Link } from 'gatsby'
import React from 'react'

type KitLookProps = {
  isKit: boolean
  linkProps: {
    to: string
    onClick: () => void
    'data-testid': string
  }
}

export default function KitLook({ isKit, linkProps }: KitLookProps) {
  if (!isKit) {
    return (
      <Link className="product-card__pdp-link" {...linkProps}>
        COMPRAR
      </Link>
    )
  }

  return (
    <a
      href={linkProps.to}
      className="product-card__pdp-link"
      onClick={linkProps?.onClick}
    >
      VER DETALHES
    </a>
  )
}
